<template>
	<div style="margin-top:15px;" class="home-wrap">
		<!-- 公告 -->
		<div class="annoucement">
			<b-card header-tag="header">
				<b-card-text class="annoucement-body">
					 <b-icon icon="volume-up" font-scale="2" style="padding-top: 5px;"></b-icon>
					<h6 style="text-align:center;font-size:16px;display: inline-block;">{{notice.title}}</h6>
				</b-card-text>		
			</b-card>
			<b-link :to="{ name: 'Notice' }" class="annoucement-more-a">点击查看更多 ></b-link>
		</div>
		<!-- 广告轮播图 -->
		<div style="margin-bottom: 15px;">
			<b-carousel id="carousel-1" v-model="slide" :interval="3000" controls indicators img-width="1024" img-height="280"
				@sliding-start="onSlideStart" @sliding-end="onSlideEnd">
				<b-carousel-slide v-for="(ad, index) in adList" :key="index" :img-src="ad.picUrl"></b-carousel-slide>
			</b-carousel>
		</div>
			<!-- 产品 -->
			<div>
				<b-row class="type-content-wrap">
					<b-col class="type-img-wrap" lg="4" v-for="(mainCate, index) in mainCateList" :key="index" v-on:click="onClickMainCate(mainCate)">
						<div class="ad" :id="mainCate.mainCategoryUuid">
							<b-img :src="mainCate.mainCategoryFile" alt="Fluid image">
							</b-img>
							<p>{{ mainCate.mainCategoryName }}</p>
						</div>
					</b-col>
					</b-row>
			</div>
			<!-- 页脚 -->
		<div class="home-footer1">
			<p>版权所有 © 广州缤纷园艺有限公司 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备05082648号</a></p>
			<p>建议使用IE10.0或以上版本浏览本网站</p>
		</div>

	</div>
</template>

<script>
	import api from '@/api/api';
	import search from '@/libs/search';
	import "@/style/global.css";
	import Vue from 'vue'
	import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
	import { BLink } from 'bootstrap-vue'
	Vue.component('b-link', BLink)
	
	Vue.use(BootstrapVue)
	Vue.use(BootstrapVueIcons)
	export default {
		name: 'Home',
		data() {
			return {
				slide: 0,
				sliding: null,
				notice: {},
				mainCateList: [],
				adList: [],
				feSearch: search.getSearchParams(),
				// selectedMainCateUuid: '',
				// selectedMainCateName: '',
			};
		},

		mounted() {
			this.getNoticeList();
			this.webGetMainCategoryList();
			this.getAdList();
		},
		methods: {
			onSlideStart(slide) {
				this.sliding = true
			},
			onSlideEnd(slide) {
				this.sliding = false
			},
			getAdList() {
				api.getAdList({
					location: 'PC广告'
				}).then(res => {
					if (res.code === 0) {
						this.adList = res.data;
						if (this.adList.length > 0) {
							for (let i = 0; i < this.adList.length; i++) {
								this.adList[i].picUrl = api.fileServer + JSON.parse(this.adList[i].picUrl).url
									.replace(/\\/g, '\/');
							}
						}
					}
				});
			},
			getNoticeList() {
				api.getNoticeList({noticeType:'公告'}).then(res => {
					if (res.code === 0) {
						if (res.data != null && res.data != '') {
							this.notice = res.data[0];
							this.notice.content=this.get_web_html(res.data[0].content);//富文本格式
						}
					}
				});
			},
			onClickMainCate(mainCate) {
				this.$router.push({
					name: 'ProductList',
					query: {
						mainCateUuid: mainCate.mainCategoryUuid,
						mainCateName: mainCate.mainCategoryName
					}
				});
			},
			onMore() {
			    this.$refs.noticeModal.showModal();
			},
			// 富文本格式
			get_web_html(richtext){
			   let content = richtext.replace(/<.+?>/g, '');    
			      content = content.replace(/ /ig, ''); /* 去除  */    
			      content = content.replace(/\s/ig, ''); /* 去除空格 */
			      return content;
			},
			webGetMainCategoryList() {
				let tempSearch = search.getSearchParams({ closeAllConditions: true });
				api.webGetMainCategoryList(tempSearch).then(res => {
					if (res.code === 0) {
						this.mainCateList = res.data.records;
						this.mainCateList.forEach(e => {
							if (e.mainCategoryFile) {
								e.mainCategoryFile = api.fileServer + JSON.parse(e.mainCategoryFile).url.replace(/\\/g, '\/');
							}
						});
					}
				});
			},
			// onClickMainCate(mainCate) {
			// 	uni.navigateTo({
			// 		url: '../subcate-list/subcate-list?mainCateUuid=' + mainCate.mainCategoryUuid + '&mainCateName=' + mainCate.mainCategoryName
			// 	});
			// },
		},
		components: {

		}
	};
</script>

<style>
/* 	.ad:nth-child(odd) {
		padding-right: 5px;
	} */

	.ad:nth-child(even) {
		padding-left: 5px;
	}

	.ad img {
		width: 100%;
		height: 80%;
		margin-bottom: 5px;
		box-shadow: 5px 5px 5px #e3e3e3e3;
		border-radius:10px;
	}
	.ad p{width: 370px;height: 45px;position:relative;bottom: 50px;border-radius:0px 0px 10px 10px;background-color: #1da25a;color:#fff;text-align: center ;padding-top:10px;}

	.annoucement .card {
		height: 50px;
		width: 100%;
		border: none;
		margin-bottom: -10px;
	}

	.annoucement .card-body {
		border: 1px solid #1da25a;
		background-color: #1da25a;
		border-radius: 5px;
	}
	.annoucement .annoucement-body {
		font-size: 14px;
		color:#fff;	
		text-align:-webkit-center;
		position:relative;
		bottom:12px	
	}

	/* 公告-更多按钮 */
	.annoucement-more-a{position: relative;bottom: 25px;float: right;padding-right:10px;color:#fff;}
	.annoucement-more-a:hover{color:#fff;}
	/* 底部 */
	.home-wrap .home-footer1 {
		width: 1170px;
		margin:0 auto;
	}

	.home-footer1 p {
		font-size: 14px;
		color: #8b8b8b;
		text-align: center;
	}

	.home-footer1 a {
		color: #8b8b8b;
	}

	.type-img-wrap .row {
		margin-left: 20px;
		margin-right: 20px;
		display: -webkit-inline-box;
	}



	.col,
	.col-1,
	.col-2,
	.col-3,
	.col-4,
	.col-5,
	.col-6,
	.col-7,
	.col-8,
	.col-9,
	.col-10,
	.col-11,
	.col-12,
	.col-auto,
	.col-lg,
	.col-lg-1,
	.col-lg-2,
	.col-lg-3,
	.col-lg-4,
	.col-lg-5,
	.col-lg-6,
	.col-lg-7,
	.col-lg-8,
	.col-lg-9,
	.col-lg-10,
	.col-lg-11,
	.col-lg-12,
	.col-lg-auto,
	.col-md,
	.col-md-1,
	.col-md-2,
	.col-md-3,
	.col-md-4,
	.col-md-5,
	.col-md-6,
	.col-md-7,
	.col-md-8,
	.col-md-9,
	.col-md-10,
	.col-md-11,
	.col-md-12,
	.col-md-auto,
	.col-sm,
	.col-sm-1,
	.col-sm-2,
	.col-sm-3,
	.col-sm-4,
	.col-sm-5,
	.col-sm-6,
	.col-sm-7,
	.col-sm-8,
	.col-sm-9,
	.col-sm-10,
	.col-sm-11,
	.col-sm-12,
	.col-sm-auto,
	.col-xl,
	.col-xl-1,
	.col-xl-2,
	.col-xl-3,
	.col-xl-4,
	.col-xl-5,
	.col-xl-6,
	.col-xl-7,
	.col-xl-8,
	.col-xl-9,
	.col-xl-10,
	.col-xl-11,
	.col-xl-12,
	.col-xl-auto {
		padding-right: 15px !important;
		padding-left: 15px !important;	
		width: 100% !important;
		position: relative !important;
	}
	.home-wrap .img-fluid{height:280px !important;}
</style>



// WEBPACK FOOTER //
// src/view/home.vue